@let firstMatchingTask = getFirstMatchingTask();
<app-page [style.max-width.px]="view() === 'mine' ? 1600 : null" size="full">
    <div class="d-flex align-items-center flex-wrap gap-3">
        <app-page-header
            [eyebrow]="pageSubtitle()"
            [title]="pageTitle()"
            class="me-2"
        ></app-page-header>
        <app-tab-group
            (valueChange)="setView($event)"
            [options]="views"
            [value]="view()"
            label="Weergave"
        ></app-tab-group>
        <mat-form-field appearance="outline" class="search" subscriptSizing="dynamic">
            <i class="fa-regular fa-magnifying-glass" matPrefix></i>
            <input
                #taskSearch
                (input)="taskSearchTerm.set(taskSearch.value)"
                (keydown.enter)="onTaskSearch(taskSearch.value)"
                aria-label="Zoeken"
                matInput
                placeholder="Zoek op nummer, klant, project of titel"
                type="text"
            />
        </mat-form-field>
        <mat-checkbox (change)="saveChangedDisplay($event.checked)" [checked]="showChanged()"
            >Laatst gewijzigd tonen</mat-checkbox
        >
        <!-- README open point 2: the function of these Azure DevOps query links is unconfirmed; they work as before -->
        <div class="query-links ms-auto">
            @for (filter of queryLinks(); track $index) {
                @if (filter) {
                    <a
                        [attr.aria-label]="filter.name"
                        [href]="filter.url"
                        [matTooltipShowDelay]="0"
                        [matTooltip]="filter.name"
                        class="query-link"
                        target="_blank"
                    >
                        <i class="fa-regular {{ filter.icon }}"></i>
                    </a>
                }
            }
        </div>
    </div>

    <app-filter-chips
        (valueChange)="statusFilter.set($event)"
        [options]="statusOptions()"
        [value]="statusFilter()"
    ></app-filter-chips>

    @switch (view()) {
        @case ('mine') {
            <div class="mine">
                <aside class="colleagues">
                    <h2>Collega's</h2>
                    @for (user of unseenUsers(); track user.id) {
                        <ng-container
                            *ngTemplateOutlet="
                                colleague;
                                context: { $implicit: user, marked: false }
                            "
                        ></ng-container>
                    }
                    @if (seenUsers().length) {
                        <div class="marked-head">
                            <span>Gemarkeerd</span>
                            @if (seenUserIds().length) {
                                <button (click)="seenUserIds.set([])" type="button">Wissen</button>
                            }
                        </div>
                        @for (user of seenUsers(); track user.id) {
                            <ng-container
                                *ngTemplateOutlet="
                                    colleague;
                                    context: { $implicit: user, marked: true }
                                "
                            ></ng-container>
                        }
                    }
                    <div class="keys">
                        <span><app-kbd>←→</app-kbd>wisselen</span>
                        <span><app-kbd>M</app-kbd>markeren</span>
                        <span><app-kbd>Ctrl ←→</app-kbd>markeren en volgende</span>
                    </div>
                </aside>

                <div class="mine-content">
                    <app-section
                        [meta]="
                            (shownTasks()[activeUserId()]?.length ?? 0) +
                            ' van ' +
                            (userTasks()[activeUserId()]?.length ?? 0) +
                            hoursMeta(activeUserId())
                        "
                        [flush]="true"
                        class="tasks"
                        icon="list-check"
                        layout="stacked"
                        title="Open taken"
                    >
                        <i
                            actions
                            class="fa-regular fa-circle-question ui-faint"
                            matTooltip="Kies met de pijltjestoetsen ↑ en ↓ een taak en open hem met enter in Azure DevOps. Sleep aan de streepjes om de volgorde te wijzigen."
                        ></i>
                        <ng-container
                            *ngTemplateOutlet="
                                taskList;
                                context: {
                                    $implicit: activeUserId(),
                                    size: 'md',
                                    empty: 'Geen taken gevonden.',
                                }
                            "
                        ></ng-container>
                        @if (getFirstMatchingTask(true) && !firstMatchingTask) {
                            <app-empty-state
                                (click)="onTaskSearch(taskSearchTerm())"
                                class="search-hint"
                                variant="filled"
                            >
                                Jouw zoekterm heeft resultaten, maar deze staan onder andere
                                collega's
                            </app-empty-state>
                        } @else if (taskSearchTerm().trim() && !getFirstMatchingTask(true)) {
                            <app-empty-state
                                (click)="onTaskSearch(taskSearchTerm())"
                                class="search-hint"
                                variant="filled"
                            >
                                Jouw zoekterm heeft geen resultaten, druk op enter om in Azure
                                DevOps te kijken of het bestaat
                                <i class="fa-regular fa-arrow-up-right-from-square ms-1"></i>
                            </app-empty-state>
                        }
                    </app-section>

                    <div class="side">
                        <app-section icon="clock" layout="stacked" title="Geregistreerde uren">
                            <a [routerLink]="['/', Routenames.registration]" actions
                                >Naar urenregistratie</a
                            >
                            <ng-container
                                *ngTemplateOutlet="
                                    hours;
                                    context: { $implicit: activeUserId(), size: 'md' }
                                "
                            ></ng-container>
                        </app-section>
                        <app-section
                            [meta]="prCountLabel(activeUserId())"
                            icon="code-pull-request"
                            layout="stacked"
                            title="Pull requests"
                        >
                            <ng-container
                                *ngTemplateOutlet="prList; context: { $implicit: activeUserId() }"
                            ></ng-container>
                        </app-section>
                    </div>
                </div>
            </div>
        }

        @case ('colleagues') {
            <div class="team">
                @for (user of visibleUsers(); track user.id) {
                    @if (userHasResults(user.id)) {
                        <div class="member">
                            <div class="member-head">
                                <app-avatar [name]="user.name" [seed]="user.id"></app-avatar>
                                <button
                                    (click)="openColleague(user.id)"
                                    [title]="'Daily van ' + user.name + ' openen'"
                                    class="member-name"
                                    type="button"
                                >
                                    {{ user.name }}
                                </button>
                                @if (markedUserIds().includes(user.id)) {
                                    <i class="fa-solid fa-star ui-ok" title="Gemarkeerd"></i>
                                }
                            </div>
                            <app-section icon="clock" layout="stacked" title="Geregistreerde uren">
                                <ng-container
                                    *ngTemplateOutlet="
                                        hours;
                                        context: { $implicit: user.id, size: 'sm' }
                                    "
                                ></ng-container>
                            </app-section>
                            <app-section
                                [flush]="true"
                                [meta]="
                                    (userTasks()[user.id]?.length ?? 0) +
                                    ' open taken' +
                                    hoursMeta(user.id)
                                "
                                icon="list-check"
                                layout="stacked"
                                title="Open taken"
                            >
                                <ng-container
                                    *ngTemplateOutlet="
                                        taskList;
                                        context: {
                                            $implicit: user.id,
                                            size: 'sm',
                                            empty: 'Geen taken voor dit filter.',
                                        }
                                    "
                                ></ng-container>
                            </app-section>
                            <app-section
                                [meta]="prCountLabel(user.id)"
                                icon="code-pull-request"
                                layout="stacked"
                                title="Pull requests"
                            >
                                <ng-container
                                    *ngTemplateOutlet="prList; context: { $implicit: user.id }"
                                ></ng-container>
                            </app-section>
                        </div>
                    }
                }
            </div>
        }

        @case ('kanban') {
            <div class="d-flex align-items-center flex-wrap gap-2">
                <span class="ui-help me-1">Medewerkers</span>
                <app-filter-chips
                    (valuesChange)="setKanbanUsers($event)"
                    [multiple]="true"
                    [options]="kanbanUserOptions()"
                    [values]="kanbanUserValues()"
                ></app-filter-chips>
            </div>
            <div
                [style.grid-template-columns]="
                    'repeat(' + kanbanColumns().length + ', minmax(260px, 1fr))'
                "
                cdkDropListGroup
                class="kanban"
            >
                @for (column of kanbanColumns(); track column.state) {
                    <section
                        [cdkDropListData]="column.state"
                        [cdkDropListDisabled]="!kanbanStatusChangeAvailable"
                        cdkDropList
                        class="kanban-column"
                    >
                        <div class="kanban-head">
                            <span [style.background]="column.dot" class="dot"></span>
                            <h2>{{ column.state }}</h2>
                            <span class="count">{{ column.items.length }}</span>
                        </div>
                        <div class="kanban-body">
                            @for (item of column.items; track item.task.id) {
                                @let task = item.task;
                                @let v = taskView(task);
                                <app-task-row
                                    (click)="updateLastClickedTask(task)"
                                    (contextmenu)="openContextMenu($event, task)"
                                    [attr.data-task-id]="task.id"
                                    [cdkDragDisabled]="!kanbanStatusChangeAvailable"
                                    [changedBy]="task.changed_by | changedByNameSplitting"
                                    [changedWhen]="
                                        task.changed_date | codaltDate: 'EEE d MMM' : true
                                    "
                                    [client]="v.client"
                                    [clientColor]="v.companyId | customerColor: 'ink'"
                                    [highlighted]="firstMatchingTask?.id === task.id"
                                    [hoursEstimate]="task.hours_estimate"
                                    [hoursSpent]="task.hours_spent"
                                    [href]="v.href"
                                    [id]="task.id"
                                    [owner]="item.owner"
                                    [parentHref]="v.parentHref"
                                    [parentId]="task.parent_id"
                                    [parentTitle]="task.parent_title"
                                    [path]="v.path"
                                    [prCount]="task.relatedPRs?.length ?? 0"
                                    [priorityLabel]="v.priorityLabel"
                                    [priority]="v.priority"
                                    [selected]="lastSelectedTask() === task.id"
                                    [showChanged]="showChanged()"
                                    [title]="task.title"
                                    [type]="task.workItemType"
                                    cdkDrag
                                    variant="card"
                                >
                                </app-task-row>
                            } @empty {
                                <app-empty-state variant="drop">Geen taken</app-empty-state>
                            }
                        </div>
                    </section>
                }
            </div>
        }
    }
</app-page>

<!-- One person in the colleague list -->
<ng-template #colleague let-marked="marked" let-user>
    @let absent = absentTodayLabels()[user.id];
    <div
        (click)="selectUser(user.id)"
        (contextmenu)="toggleUserSeen($event, user.id)"
        [class.active]="activeUserId() === user.id"
        [class.marked]="marked"
        class="colleague"
    >
        <app-avatar [name]="user.name" [seed]="user.id" size="sm"></app-avatar>
        <span class="who">
            <span class="name"
                >{{ user.name }}
                @if (user.id === LocalStorage.user?.id) {
                    <span class="me"> · jij</span>
                }
            </span>
            @if (absent) {
                <span class="absent">{{ absent.name }} {{ absent.time }}</span>
            }
        </span>
        <button
            (click)="$event.stopPropagation(); toggleUserSeen($event, user.id)"
            [attr.aria-label]="marked ? 'Markering weghalen (M)' : 'Markeren (M)'"
            [title]="marked ? 'Markering weghalen (M)' : 'Markeren (M)'"
            class="star"
            type="button"
        >
            <i [class]="marked ? 'fa-solid fa-star' : 'fa-regular fa-star'"></i>
        </button>
    </div>
</ng-template>

<!-- Open tasks of a user; the priority stripes are the drag handle to reorder (saved per user) -->
<ng-template #taskList let-empty="empty" let-size="size" let-userId>
    <div
        (cdkDropListDropped)="dropTask($event, userId)"
        [cdkDropListDisabled]="taskSortingDisabled()"
        cdkDropList
        class="task-list"
    >
        @for (task of shownTasks()[userId] ?? []; track task.id) {
            @let v = taskView(task);
            <app-task-row
                (click)="updateLastClickedTask(task)"
                (contextmenu)="openContextMenu($event, task)"
                [attr.data-task-id]="task.id"
                [cdkDragDisabled]="!isDraggableTask(task)"
                [changedBy]="task.changed_by | changedByNameSplitting"
                [changedWhen]="task.changed_date | codaltDate: 'EEE d MMM' : true"
                [client]="v.client"
                [clientColor]="v.companyId | customerColor: 'ink'"
                [dragHandle]="isDraggableTask(task) && !taskSortingDisabled()"
                [highlighted]="firstMatchingTask?.id === task.id"
                [hoursEstimate]="task.hours_estimate"
                [hoursSpent]="task.hours_spent"
                [href]="v.href"
                [id]="task.id"
                [parentHref]="v.parentHref"
                [parentId]="task.parent_id"
                [parentTitle]="task.parent_title"
                [path]="v.path"
                [prCount]="task.relatedPRs?.length ?? 0"
                [priorityLabel]="v.priorityLabel"
                [priority]="v.priority"
                [selected]="lastSelectedTask() === task.id"
                [showChanged]="showChanged()"
                [size]="size"
                [statusTone]="v.statusTone"
                [status]="task.state"
                [title]="task.title"
                [type]="task.workItemType"
                cdkDrag
            >
            </app-task-row>
        } @empty {
            <app-empty-state>{{ empty }}</app-empty-state>
        }
    </div>
</ng-template>

<!-- Geregistreerde uren: two weeks of day bars -->
<ng-template #hours let-size="size" let-userId>
    @for (week of hoursByUser()[userId] ?? []; track week.title) {
        <!-- Double-clicking one of your own days opens Urenregistratie on that day -->
        <app-hours-week
            (dayDblClick)="openRegistration($event)"
            [days]="week.days"
            [openableDays]="userId === LocalStorage.user?.id"
            [range]="week.range"
            [size]="size"
            [title]="week.title"
            [totalMinutes]="week.totalMinutes"
            class="hours-week"
        />
    }
</ng-template>

<!-- Open pull requests of a user, per Azure project -->
<ng-template #prList let-userId>
    @for (group of prGroups()[userId] ?? []; track group.project) {
        <div class="pr-group">{{ group.project }}</div>
        @if (group.error) {
            <div class="ui-meta ui-error">Fout: {{ group.error }}</div>
        }
        @for (item of group.prs; track item.pr.pullRequestId) {
            <app-pr-card
                (contextmenu)="openContextMenuForPR($event, item.pr, item.project)"
                [draft]="item.pr.isDraft"
                [href]="item.href"
                [mergeStatus]="item.pr.mergeStatus"
                [number]="item.pr.pullRequestId"
                [reviewers]="item.reviewers"
                [title]="item.pr.title"
                [when]="item.when"
                variant="row"
            >
            </app-pr-card>
        }
    } @empty {
        <div class="ui-help py-1">Geen open pull requests.</div>
    }
</ng-template>

<ng-template #taskContextMenu>
    <div class="context-menu-panel">
        @for (platform of contextMenuTask().platform; track platform.id) {
            <div class="context-menu-header">{{ platform.name }}</div>
            @if (platform.prod_url) {
                <a
                    [href]="platform.prod_url | urlCombining: contextMenuTask().azure_task.url"
                    class="context-menu-cell"
                    target="_blank"
                >
                    <span>Prod</span>
                    <p>
                        {{
                            platform.prod_url
                                | urlCombining: contextMenuTask().azure_task.url
                                | urlPrefixStripping
                        }}
                    </p>
                </a>
            }
            @if (platform.acc_url) {
                <a
                    [href]="platform.acc_url | urlCombining: contextMenuTask().azure_task.url"
                    class="context-menu-cell"
                    target="_blank"
                >
                    <span>Acc</span>
                    <p>
                        {{
                            platform.acc_url
                                | urlCombining: contextMenuTask().azure_task.url
                                | urlPrefixStripping
                        }}
                    </p>
                </a>
            }
            @if (platform.test_url) {
                <a
                    [href]="platform.test_url | urlCombining: contextMenuTask().azure_task.url"
                    class="context-menu-cell"
                    target="_blank"
                >
                    <span>Test</span>
                    <p>
                        {{
                            platform.test_url
                                | urlCombining: contextMenuTask().azure_task.url
                                | urlPrefixStripping
                        }}
                    </p>
                </a>
            }
            @if (platform.local_url) {
                <a
                    [href]="platform.local_url | urlCombining: contextMenuTask().azure_task.url"
                    class="context-menu-cell"
                    target="_blank"
                >
                    <span>Local</span>
                    <p>
                        {{
                            platform.local_url
                                | urlCombining: contextMenuTask().azure_task.url
                                | urlPrefixStripping
                        }}
                    </p>
                </a>
            }
        } @empty {
            <div class="context-menu-empty">Er zijn geen URLs gevonden</div>
        }
        @if (contextMenuTask().relatedPRs?.length) {
            <div class="context-menu-header">Pull requests</div>
            @for (item of contextMenuTask().relatedPRs; track item.pr.pullRequestId) {
                <a
                    [href]="
                        'https://dev.azure.com/codalt/' +
                        item.project +
                        '/_git/' +
                        item.pr.repository.name +
                        '/pullrequest/' +
                        item.pr.pullRequestId +
                        '?_a=files'
                    "
                    class="context-menu-cell"
                    target="_blank"
                >
                    <span>!{{ item.pr.pullRequestId }}</span>
                    <p>
                        {{ item.pr.title }}
                        <small
                            >{{ item.pr.creationDate | codaltDate: 'EEE d MMM' : true }} -
                            {{ item.pr.createdBy?.displayName }}</small
                        >
                    </p>
                </a>
                @if (item.pr.repository.name === 'Planning') {
                    <a
                        class="context-menu-cell"
                        href="https://pr-{{ item.pr.pullRequestId }}-dvds.planning.codalt.com/"
                        target="_blank"
                    >
                        <span>!{{ item.pr.pullRequestId }}</span>
                        <p>DvdS - test</p>
                    </a>
                    <a
                        class="context-menu-cell"
                        href="https://pr-{{ item.pr.pullRequestId }}-dvds.geo.codalt.com/"
                        target="_blank"
                    >
                        <span>!{{ item.pr.pullRequestId }}</span>
                        <p>DvdS - geo</p>
                    </a>
                    <a
                        class="context-menu-cell"
                        href="https://pr-{{ item.pr.pullRequestId }}-trackline.planning.codalt.com/"
                        target="_blank"
                    >
                        <span>!{{ item.pr.pullRequestId }}</span>
                        <p>Track Line - test</p>
                    </a>
                }
            }
        }
    </div>
</ng-template>
